import { all } from 'redux-saga/effects'
import { saga as appSaga } from '../ducks/app'
import { saga as authSaga } from '../ducks/auth'
import { saga as propertiesSaga } from '../ducks/properties'
import { saga as chartSaga } from '../ducks/chart'
import { saga as productsSaga } from '../ducks/products'
import { saga as statesSaga } from '../ducks/states'
import { saga as interactionSaga } from '../ducks/interaction'
import { saga as interactionsSaga } from '../ducks/interactions'
import { saga as createInteractionSaga } from '../ducks/createInteraction'
import { saga as contractsSaga } from '../ducks/contracts'
import { saga as transactionsSaga } from '../ducks/transactions'
import { saga as emailSaga } from '../ducks/email'
import { saga as newsSaga } from '../ducks/news'
import { saga as interactionsPreviewSaga } from '../ducks/interactionsPreview'
import { saga as toolsSaga } from '../ducks/tools'

export default function* rootSaga() {
  yield all([
    appSaga(),
    authSaga(),
    emailSaga(),
    propertiesSaga(),
    chartSaga(),
    productsSaga(),
    statesSaga(),
    interactionSaga(),
    interactionsSaga(),
    createInteractionSaga(),
    contractsSaga(),
    transactionsSaga(),
    newsSaga(),
    interactionsPreviewSaga(),
    toolsSaga()
  ])
}
